export default "__VITE_ASSET__OYVgG7tY__"